import Dispatcher from '../dispatchers/dispatcher';

const Actions = {
  clearPolling: () => Dispatcher.dispatch({ type: 'clearPolling' }),
  pausePolling: () => Dispatcher.dispatch({ type: 'pausePolling' }),
  resumePolling: () => Dispatcher.dispatch({ type: 'resumePolling' }),
  isPollingPaused: () => Dispatcher.dispatch({ type: 'isPollingPaused' }),
  setLastPollStartTime: () => Dispatcher.dispatch({ type: 'setLastPollStartTime' }),
  isPollingActive: (data) => Dispatcher.dispatch({ type: 'isPollingActive', data }),

  pollEligibility: (data) => Dispatcher.dispatch({ type: 'pollEligibility', data }),
  beginPollEligibilitySlow: (data) => Dispatcher.dispatch({ type: 'beginPollEligibilitySlow', data }),
  beginPollEligibilityFast: (data) => Dispatcher.dispatch({ type: 'beginPollEligibilityFast', data }),
  beginPollSignatures: (data) => Dispatcher.dispatch({ type: 'beginPollSignatures', data }),
  beginPollFinancingMethod: () => Dispatcher.dispatch({ type: 'beginPollFinancingMethod' }),
  beginPollCreditTasks: (data) => Dispatcher.dispatch({ type: 'beginPollCreditTasks', data }),
  beginProposalPagePolling: (data) => Dispatcher.dispatch({ type: 'beginProposalPagePolling', data }),
  beginPollPrescreen: (data, cb) => Dispatcher.dispatch({ type: 'beginPollPrescreen', data: { data, cb } }),
  beginStatusNotesPolling: () => Dispatcher.dispatch({ type: 'beginStatusNotesPolling' }),
  beginPollDecision: () => Dispatcher.dispatch({ type: 'beginPollDecision' }),

  endPollPrescreen: () => Dispatcher.dispatch({ type: 'endPolling', data: 'fetchPrescreen' }),
  endPollEligibility: () => Dispatcher.dispatch({ type: 'endPolling', data: 'fetchEligibility' }),
  endPollSignatures: () => Dispatcher.dispatch({ type: 'endPolling', data: 'fetchSignature' }),
  endPollFinancingMethod: () => Dispatcher.dispatch({ type: 'endPolling', data: 'refreshFinancingMethods' }),
  endPollFinancingRequest: () => Dispatcher.dispatch({ type: 'endPolling', data: 'fetchFinancingRequest' }),
  endPollCreditTasks: () => Dispatcher.dispatch({ type: 'endPolling', data: 'getCreditTasks' }),

  cancelStepDocEnvelope: (data) => Dispatcher.dispatch({ type: 'cancelStepDocEnvelope', data }),

  resendStepDocEnvelope: (data) => Dispatcher.dispatch({ type: 'resendStepDocEnvelope', data }),

  clearCustomer: () => Dispatcher.dispatch({ type: 'clearCustomer' }),
  clearFinancingMethod: () => Dispatcher.dispatch({ type: 'clearFinancingMethod' }),
  clearProposal: (data) => Dispatcher.dispatch({ type: 'clearProposal', data }),
  clearEligibility: (data) => Dispatcher.dispatch({ type: 'clearEligibility', data }),

  createProposal: (data) => Dispatcher.dispatch({ type: 'createProposal', data }),

  deleteDocuments: (data) => Dispatcher.dispatch({ type: 'documentsDelete', data }),

  deleteFinancingRequest: (data) => Dispatcher.dispatch({ type: 'deleteFinancingRequest', data }),

  prepareForPrescreen: (data) => Dispatcher.dispatch({ type: 'prepareForPrescreen', data }),

  setLastEvent: (data) => Dispatcher.dispatch({ type: 'setLastEvent', data }),

  setRecaptchaToken: (data) => Dispatcher.dispatch({ type: 'setRecaptchaToken', data }),

  getGenericMarketingUrl: () => Dispatcher.dispatch({ type: 'getGenericMarketingUrl' }),

  getIndividualMarketingUrl: (data) => Dispatcher.dispatch({ type: 'getIndividualMarketingUrl', data }),

  acquireLock: (data) => Dispatcher.dispatch({ type: 'acquireLock', data }),

  releaseLock: (data) => Dispatcher.dispatch({ type: 'releaseLock', data }),

  deleteStipDocuments: (data) => Dispatcher.dispatch({ type: 'deleteStipDocuments', data }),

  eligibilityDelete: (data) => Dispatcher.dispatch({ type: 'eligibilityDelete', data }),

  fetchFinancingCalculationModels: (data) => Dispatcher.dispatch({ type: 'fetchFinancingCalculationModels', data }),

  fetchPlaidLink: (data) => Dispatcher.dispatch({ type: 'fetchPlaidLink', data }),
  fetchPlaidAccessLink: (data) => Dispatcher.dispatch({ type: 'fetchPlaidAccessLink', data }),

  setAutoPayOptIn: (data) => Dispatcher.dispatch({ type: 'setAutoPayOptIn', data }),
  setEnrollmentStatus: (data) => Dispatcher.dispatch({ type: 'setEnrollmentStatus', data }),

  logAutoPayEvent: (data) => Dispatcher.dispatch({ type: 'logAutoPayEvent', data }),

  fetchPlaidACH: (data) => Dispatcher.dispatch({ type: 'fetchPlaidACH', data }),

  fetchAutoPay: (data) => Dispatcher.dispatch({ type: 'fetchAutoPay', data }),

  fetchEligibility: (data) => Dispatcher.dispatch({ type: 'fetchEligibility', data }),

  fetchHomeownerStips: (data) => Dispatcher.dispatch({ type: 'fetchHomeownerStips', data }),

  fetchFunctionalityAcls: (data) => Dispatcher.dispatch({ type: 'fetchFunctionalityAcls', data }),

  fetchSystemArrays: (data) => Dispatcher.dispatch({ type: 'fetchSystemArrays', data }),

  refreshFinancingMethods: () => Dispatcher.dispatch({ type: 'refreshFinancingMethods' }),

  fetchAuthenticatedUser: () => Dispatcher.dispatch({ type: 'fetchAuthenticatedUser' }),

  clearCustomersList: () => Dispatcher.dispatch({ type: 'clearCustomersList' }),

  getSearchParams: () => Dispatcher.dispatch({ type: 'getSearchParams' }),

  fetchCustomer: (data) => Dispatcher.dispatch({ type: 'fetchCustomer', data }),

  fetchCustomerEvents: (data) => Dispatcher.dispatch({ type: 'fetchCustomerEvents', data }),

  fetchCustomerSponsorEvents: (data) => Dispatcher.dispatch({ type: 'fetchCustomerSponsorEvents', data }),

  fetchCustomers: (data) => Dispatcher.dispatch({ type: 'fetchCustomers', data }),

  fetchCustomersV3: (data) => Dispatcher.dispatch({ type: 'fetchCustomersV3', data }),

  fetchCustomersList: (data) => Dispatcher.dispatch({ type: 'fetchCustomersList', data }),

  fetchPaymentPageConfig: () => Dispatcher.dispatch({ type: 'fetchPaymentPageConfig' }),

  clearPaymentPageConfig: () => Dispatcher.dispatch({ type: 'clearPaymentPageConfig' }),

  fetchViewableOwners: (data) => Dispatcher.dispatch({ type: 'fetchViewableOwners', data }),

  showDuplicateEmailModal: (data) => Dispatcher.dispatch({ type: 'showDuplicateEmailModal', data }),

  fetchEnergyDetails: (data) => Dispatcher.dispatch({ type: 'fetchEnergyDetails', data }),

  fetchElements: (data) => Dispatcher.dispatch({ type: 'fetchElements', data }),

  getFinancingMethod: (data) => Dispatcher.dispatch({ type: 'getFinancingMethod', data }),

  fetchCreditDocuments: (data) => Dispatcher.dispatch({ type: 'fetchCreditDocuments', data }),

  fetchLegalDocuments: (data) => Dispatcher.dispatch({ type: 'fetchLegalDocuments', data }),

  fetchPrescreen: (data) => Dispatcher.dispatch({ type: 'fetchPrescreen', data }),

  clearPrescreen: () => Dispatcher.dispatch({ type: 'clearPrescreen' }),

  fetchProposal: (data) => Dispatcher.dispatch({ type: 'fetchProposal', data }),

  financeProposal: (data) => Dispatcher.dispatch({ type: 'financeProposal', data }),

  goToProposalPage: (data) => Dispatcher.dispatch({ type: 'goToProposalPage', data }),

  handleRequestError: (data) => Dispatcher.dispatch({ type: 'handleRequestError', data }),

  legalDocumentsDelete: (data) => Dispatcher.dispatch({ type: 'legalDocumentsDelete', data }),

  logIn: (data) => Dispatcher.dispatch({ type: 'logIn', data }),

  submitPasswordChangeForm: (data) => Dispatcher.dispatch({ type: 'submitPasswordChangeForm', data }),

  submitEmailChangeForm: (data) => Dispatcher.dispatch({ type: 'submitEmailChangeForm', data }),

  logOut: (data) => Dispatcher.dispatch({ type: 'logOut', data }),

  openProposalDocument: (data) => Dispatcher.dispatch({ type: 'openProposalDocument', data }),

  previewProposal: (data) => Dispatcher.dispatch({ type: 'previewProposal', data }),

  persistCustomerStatusUpdate: (data) => Dispatcher.dispatch({ type: 'persistCustomerStatusUpdate', data }),

  preScreenCustomer: (data) => Dispatcher.dispatch({ type: 'preScreenCustomer', data }),

  createThirdPartyLead: (data) => Dispatcher.dispatch({ type: 'createThirdPartyLead', data }),

  saveEligibility: (data) => Dispatcher.dispatch({ type: 'saveEligibility', data }),

  sendHomeownerStips: (data) => Dispatcher.dispatch({ type: 'sendHomeownerStips', data }),

  setAmountFinancedOverridden: (data) => Dispatcher.dispatch({ type: 'setAmountFinancedOverridden', data }),

  setRTDRCurrentDecisioningDocSku: (data) => Dispatcher.dispatch({ type: 'setRTDRCurrentDecisioningDocSku', data }),

  requestAdditionalFiles: (data) => Dispatcher.dispatch({ type: 'requestAdditionalFiles', data }),

  setCustomer: (data) => Dispatcher.dispatch({ type: 'setCustomer', data }),

  setCustomerResults: (data) => Dispatcher.dispatch({ type: 'setCustomerResults', data }),

  setErrorMessages: (data) => Dispatcher.dispatch({ type: 'setErrorMessages', data }),

  setFinancingMethod: (data) => Dispatcher.dispatch({ type: 'setFinancingMethod', data }),

  setFinancingMethodToFetch: (data) => Dispatcher.dispatch({ type: 'setFinancingMethodToFetch', data }),

  setMessages: (data) => Dispatcher.dispatch({ type: 'setMessages', data }),

  sendDocumentsForSignatureViaEmail: (data) => Dispatcher.dispatch({ type: 'sendDocumentsForSignatureViaEmail', data }),

  sendForSMSSignature: (data) => Dispatcher.dispatch({ type: 'sendForSMSSignature', data }),

  sendForSMSSignatureOverride: (data) => Dispatcher.dispatch({ type: 'sendForSMSSignatureOverride', data }),

  deleteSMSSignatureRequest: (data) => Dispatcher.dispatch({ type: 'deleteSMSSignatureRequest', data }),

  setProposal: (data) => Dispatcher.dispatch({ type: 'setProposal', data }),

  setCustomerListFinancingRequestId: (data) => Dispatcher.dispatch({ type: 'setCustomerListFinancingRequestId', data }),

  setModalDataEntryOnSubmit: (data) => Dispatcher.dispatch({ type: 'setModalDataEntryOnSubmit', data }),

  modalDataEntryOnSubmit: () => Dispatcher.dispatch({ type: 'modalDataEntryOnSubmit' }),

  setRoute: (data) => Dispatcher.dispatch({ type: 'setRoute', data }),

  setView: (data) => Dispatcher.dispatch({ type: 'setView', data }),

  signDocuments: (data) => Dispatcher.dispatch({ type: 'signDocuments', data }),

  createFinancingRequest: (data) => Dispatcher.dispatch({ type: 'createFinancingRequest', data }),

  signHomeownerPacket: (data) => Dispatcher.dispatch({ type: 'signHomeownerPacket', data }),

  signUp: (data) => Dispatcher.dispatch({ type: 'signUp', data }),

  submitEligibilityEmail: (data) => Dispatcher.dispatch({ type: 'submitEligibilityEmail', data }),

  submitEligibilityUFO: (data) => Dispatcher.dispatch({ type: 'submitEligibilityUFO', data }),

  submitEligibility: (data) => Dispatcher.dispatch({ type: 'submitEligibility', data }),

  submitEligibilityByFinanceManager: (data) => Dispatcher.dispatch({ type: 'submitEligibilityByFinanceManager', data }),

  impersonateUser: (data) => Dispatcher.dispatch({ type: 'impersonateUser', data }),

  impersonateCustomerOwner: (data) => Dispatcher.dispatch({ type: 'impersonateCustomerOwner', data }),

  updateCustomer: (data) => Dispatcher.dispatch({ type: 'updateCustomer', data }),

  updateListViewCustomer: (data) => Dispatcher.dispatch({ type: 'updateListViewCustomer', data }),

  updateFinancingMethod: (data) => Dispatcher.dispatch({ type: 'updateFinancingMethod', data }),

  userAgreesTermsOfUse: () => Dispatcher.dispatch({ type: 'userAgreesTermsOfUse' }),

  zipCodeSet: (data) => Dispatcher.dispatch({ type: 'zipCodeSet', data }),

  toggleCoApplicantForm: (data) => Dispatcher.dispatch({ type: 'toggleCoApplicantForm', data }),

  submitPaperCredit: (data) => Dispatcher.dispatch({ type: 'submitPaperCredit', data }),

  fetchProperty: (data) => Dispatcher.dispatch({ type: 'fetchProperty', data }),

  fetchStipStatusNotes: (data) => Dispatcher.dispatch({ type: 'fetchStipStatusNotes', data }),

  fetchFinancingRequest: (data) => Dispatcher.dispatch({ type: 'fetchFinancingRequest', data }),

  fetchWorkflowProofOverrides: (data) => Dispatcher.dispatch({ type: 'fetchWorkflowProofOverrides', data }),

  fetchCustomerInverterMonitoring: (data) => Dispatcher.dispatch({ type: 'fetchCustomerInverterMonitoring', data }),

  fetchStepDocRevisionBytes: (data) => Dispatcher.dispatch({ type: 'fetchStepDocRevisionBytes', data }),

  openStepDocRevisionBytes: (data) => Dispatcher.dispatch({ type: 'openStepDocRevisionBytes', data }),

  fetchHomeownerPacketRevisionBytes: (data) => Dispatcher.dispatch({ type: 'fetchHomeownerPacketRevisionBytes', data }),

  generateDataEntryStepDocRevision: (data) => Dispatcher.dispatch({ type: 'generateDataEntryStepDocRevision', data }),

  sendPTODataEntry: (data) => Dispatcher.dispatch({ type: 'sendPTODataEntry', data }),

  generateIRStepDocRevision: (data) => Dispatcher.dispatch({ type: 'generateIRStepDocRevision', data }),

  uploadStepDocRevision: (data) => Dispatcher.dispatch({ type: 'uploadStepDocRevision', data }),

  uploadStepDocCustomerRevision: (data) => Dispatcher.dispatch({ type: 'uploadStepDocCustomerRevision', data }),

  deleteStepDocRevision: (data) => Dispatcher.dispatch({ type: 'deleteStepDocRevision', data }),

  signStepDocs: (data) => Dispatcher.dispatch({ type: 'signStepDocs', data }),

  fetchHomeownerEligibilityData: (data) => Dispatcher.dispatch({ type: 'fetchHomeownerEligibilityData', data }),

  submitHomeownerEligibility: (data) => Dispatcher.dispatch({ type: 'submitHomeownerEligibility', data }),

  fetchVerifiedSigners: () => Dispatcher.dispatch({ type: 'fetchVerifiedSigners' }),

  clearVerifiedSigners: () => Dispatcher.dispatch({ type: 'clearVerifiedSigners' }),

  clearSendForSignatureList: () => Dispatcher.dispatch({ type: 'clearSendForSignatureList' }),

  updateSendForSignatureList: (data) => Dispatcher.dispatch({ type: 'updateSendForSignatureList', data }),

  sendStepDocsForSignatureByEmail: (data) => Dispatcher.dispatch({ type: 'sendStepDocsForSignatureByEmail', data }),

  postDiscussion: (data) => Dispatcher.dispatch({ type: 'postDiscussion', data }),

  getDiscussions: (data) => Dispatcher.dispatch({ type: 'getDiscussions', data }),

  fetchMeasures: (data) => Dispatcher.dispatch({ type: 'fetchMeasures', data }),

  retrieveApprovedVendors: (data) => Dispatcher.dispatch({ type: 'retrieveApprovedVendors', data }),

  fetchUserPreferredEmail: () => Dispatcher.dispatch({ type: 'fetchUserPreferredEmail' }),

  fetchAdminFinancingRequest: (data) => Dispatcher.dispatch({ type: 'fetchAdminFinancingRequest', data }),

  fetchAdminFinancingRequestHistory: (data) => Dispatcher.dispatch({ type: 'fetchAdminFinancingRequestHistory', data }),

  fetchDecisions: (data) => Dispatcher.dispatch({ type: 'fetchDecisions', data }),

  gotoDecisionList: (data) => Dispatcher.dispatch({ type: 'gotoDecisionList', data }),

  clearDecisions: () => Dispatcher.dispatch({ type: 'clearDecisions' }),

  clearDecisionData: () => Dispatcher.dispatch({ type: 'clearDecisionData' }),

  submitDocDecision: (data) => Dispatcher.dispatch({ type: 'submitDocDecision', data }),

  submitBulkDocDecision: (data) => Dispatcher.dispatch({ type: 'submitBulkDocDecision', data }),

  countStepDocsAndFrsInTierView: (data) => Dispatcher.dispatch({ type: 'countStepDocsAndFrsInTierView', data }),

  fetchFrDocumentsTier1: (data) => Dispatcher.dispatch({ type: 'fetchFrDocumentsTier1', data }),

  fetchFrDocumentsTier2: (data) => Dispatcher.dispatch({ type: 'fetchFrDocumentsTier2', data }),

  fetchFrDocumentsEscalated: (data) => Dispatcher.dispatch({ type: 'fetchFrDocumentsEscalated', data }),

  fetchUserSettingValues: (data) => Dispatcher.dispatch({ type: 'fetchUserSettingValues', data }),

  fetchVipReport: (data) => Dispatcher.dispatch({ type: 'fetchVipReport', data }),

  fetchVipSummary: (data) => Dispatcher.dispatch({ type: 'fetchVipSummary', data }),

  saveInternalNotes: (data) => Dispatcher.dispatch({ type: 'saveInternalNotes', data }),

  fetchAdminProposals: (data) => Dispatcher.dispatch({ type: 'fetchAdminProposals', data }),

  createAdminProposalMeasures: (data) => Dispatcher.dispatch({ type: 'createAdminProposalMeasures', data }),

  clearAdminFinancingRequest: (data) => Dispatcher.dispatch({ type: 'clearAdminFinancingRequest', data }),

  logInToProposalAsUser: (data) => Dispatcher.dispatch({ type: 'logInToProposalAsUser', data }),

  lockAdminFinancingRequest: (data) => Dispatcher.dispatch({ type: 'lockAdminFinancingRequest', data }),

  unlockAdminFinancingRequest: (data) => Dispatcher.dispatch({ type: 'unlockAdminFinancingRequest', data }),

  initiateStepDocsInPersonSigning: (data) => Dispatcher.dispatch({ type: 'initiateStepDocsInPersonSigning', data }),

  fetchDocHistory: (data) => Dispatcher.dispatch({ type: 'fetchDocHistory', data }),

  saveFinancingMethodUpdates: (data) => Dispatcher.dispatch({ type: 'saveFinancingMethodUpdates', data }),

  fetchFinancingProductElements: (data) => Dispatcher.dispatch({ type: 'fetchFinancingProductElements', data }),

  saveASDSystemArray: (data) => Dispatcher.dispatch({ type: 'saveASDSystemArray', data }),

  deleteASDSystemArray: (data) => Dispatcher.dispatch({ type: 'deleteASDSystemArray', data }),

  fetchAdvancedSystemArrays: (data) => Dispatcher.dispatch({ type: 'fetchAdvancedSystemArrays', data }),

  clearAdvancedSystemArrays: () => Dispatcher.dispatch({ type: 'clearAdvancedSystemArrays' }),

  updatePvArrayShading: (data) => Dispatcher.dispatch({ type: 'updatePvArrayShading', data }),

  setInlineManualUserTracking: (data) => Dispatcher.dispatch({ type: 'setInlineManualUserTracking', data }),

  downloadDisbursementReport: (data) => Dispatcher.dispatch({ type: 'downloadDisbursementReport', data }),

  sendDocumentsForSignature: (data) => Dispatcher.dispatch({ type: 'sendDocumentsForSignature', data }),

  triggerAddressInfo: (data) => Dispatcher.dispatch({ type: 'triggerAddressInfo', data }),

  triggerUtilityAccountInfo: (data) => Dispatcher.dispatch({ type: 'triggerUtilityAccountInfo', data }),

  fetchGuestResumeUrl: (data) => Dispatcher.dispatch({ type: 'fetchGuestResumeUrl', data }),

  guestAuth: () => Dispatcher.dispatch({ type: 'guestAuth' }),

  askForResumeApplicationEmail: (data) => Dispatcher.dispatch({ type: 'askForResumeApplicationEmail', data }),

  askForResumeTokenInfo: (data) => Dispatcher.dispatch({ type: 'askForResumeTokenInfo', data }),

  askForResumeApplicationSession: (data) => Dispatcher.dispatch({ type: 'askForResumeApplicationSession', data }),

  setDefaultServiceAddressType: (data) => Dispatcher.dispatch({ type: 'setDefaultServiceAddressType', data }),

  setCustomerFormValid: (data) => Dispatcher.dispatch({ type: 'setCustomerFormValid', data }),

  setUserInputLoanAmountIsInvalid: (data) => Dispatcher.dispatch({ type: 'setUserInputLoanAmountIsInvalid', data }),

  startEditModeReview: () => Dispatcher.dispatch({ type: 'startEditModeReview' }),

  endEditModeReview: () => Dispatcher.dispatch({ type: 'endEditModeReview' }),

  fetchVerification: (data) => Dispatcher.dispatch({ type: 'fetchVerification', data }),

  fetchDecisionTable: (data) => Dispatcher.dispatch({ type: 'fetchDecisionTable', data }),

  fetchDecisionTableInactive: (data) => Dispatcher.dispatch({ type: 'fetchDecisionTableInactive', data }),

  fetchDecisionPage: (data) => Dispatcher.dispatch({ type: 'fetchDecisionPage', data }),

  fetchDecisionProcessDenialReasons: (data) => Dispatcher.dispatch({ type: 'fetchDecisionProcessDenialReasons', data }),

  fetchDecisionUsers: (data) => Dispatcher.dispatch({ type: 'fetchDecisionUsers', data }),

  fetchFile: (data) => Dispatcher.dispatch({ type: 'fetchFile', data }),

  fetchUserList: (data) => Dispatcher.dispatch({ type: 'fetchUserList', data }),

  clearActiveUserList: () => Dispatcher.dispatch({ type: 'clearActiveUserList' }),

  clearInactiveUserList: () => Dispatcher.dispatch({ type: 'clearInactiveUserList' }),

  fetchUser: (data) => Dispatcher.dispatch({ type: 'fetchUser', data }),

  fetchUserByCustomer: (data) => Dispatcher.dispatch({ type: 'fetchUserByCustomer', data }),

  fetchDecisionUserByCustomer: (data) => Dispatcher.dispatch({ type: 'fetchDecisionUserByCustomer', data }),

  fetchCompanyList: (data) => Dispatcher.dispatch({ type: 'fetchCompanyList', data }),

  fetchCompany: (data) => Dispatcher.dispatch({ type: 'fetchCompany', data }),

  fetchCompanyAdminContactInfo: (data) => Dispatcher.dispatch({ type: 'fetchCompanyAdminContactInfo', data }),

  migrateCompanyProduct: (data) => Dispatcher.dispatch({ type: 'migrateCompanyProduct', data }),

  fetchCompanyWithAdmin: (data) => Dispatcher.dispatch({ type: 'fetchCompanyWithAdmin', data }),

  fetchCompanyElementTypeForm: (data) => Dispatcher.dispatch({ type: 'fetchCompanyElementTypeForm', data }),

  fetchCompanyPaymentPrograms: (data) => Dispatcher.dispatch({ type: 'fetchCompanyPaymentPrograms', data }),

  fetchCompanyAuditLogs: (data) => Dispatcher.dispatch({ type: 'fetchCompanyAuditLogs', data }),

  clearCompanyList: () => Dispatcher.dispatch({ type: 'clearCompanyList' }),

  clearCompany: () => Dispatcher.dispatch({ type: 'clearCompany' }),

  createCompany: (data) => Dispatcher.dispatch({ type: 'createCompany', data }),

  updateCompany: (data) => Dispatcher.dispatch({ type: 'updateCompany', data }),

  clearUser: () => Dispatcher.dispatch({ type: 'clearUser' }),

  newUser: (data) => Dispatcher.dispatch({ type: 'newUser', data }),

  createUser: (data) => Dispatcher.dispatch({ type: 'createUser', data }),

  getRatesList: (data) => Dispatcher.dispatch({ type: 'getRatesList', data }),

  getBranchList: (data) => Dispatcher.dispatch({ type: 'getBranchList', data }),
  clearBranchList: () => Dispatcher.dispatch({ type: 'clearBranchList' }),
  getBranch: (data) => Dispatcher.dispatch({ type: 'getBranch', data }),
  createBranch: (data) => Dispatcher.dispatch({ type: 'createBranch', data }),
  updateBranch: (data) => Dispatcher.dispatch({ type: 'updateBranch', data }),
  deleteBranch: (data) => Dispatcher.dispatch({ type: 'deleteBranch', data }),
  hardDeleteBranch: (data) => Dispatcher.dispatch({ type: 'hardDeleteBranch', data }),
  clearBranch: () => Dispatcher.dispatch({ type: 'clearBranch' }),

  createPricingGroup: (data) => Dispatcher.dispatch({ type: 'createPricingGroup', data }),
  updatePricingGroup: (data) => Dispatcher.dispatch({ type: 'updatePricingGroup', data }),
  clearPricingGroupList: () => Dispatcher.dispatch({ type: 'clearPricingGroupList' }),
  getPricingGroupList: (data) => Dispatcher.dispatch({ type: 'getPricingGroupList', data }),
  getPricingGroup: (data) => Dispatcher.dispatch({ type: 'getPricingGroup', data }),
  clearPricingGroup: () => Dispatcher.dispatch({ type: 'clearPricingGroup' }),

  createLicense: (data) => Dispatcher.dispatch({ type: 'createLicense', data }),
  updateLicense: (data) => Dispatcher.dispatch({ type: 'updateLicense', data }),
  bulkUpdateLicenses: (data) => Dispatcher.dispatch({ type: 'bulkUpdateLicenses', data }),
  clearLicenseList: () => Dispatcher.dispatch({ type: 'clearLicenseList' }),
  getLicenseList: (data) => Dispatcher.dispatch({ type: 'getLicenseList', data }),
  getUserLicenseList: (data) => Dispatcher.dispatch({ type: 'getUserLicenseList', data }),
  getLicense: (data) => Dispatcher.dispatch({ type: 'getLicense', data }),
  clearLicense: () => Dispatcher.dispatch({ type: 'clearLicense' }),
  deleteLicense: (data) => Dispatcher.dispatch({ type: 'deleteLicense', data }),
  hardDeleteLicense: (data) => Dispatcher.dispatch({ type: 'hardDeleteLicense', data }),

  updateUser: (data) => Dispatcher.dispatch({ type: 'updateUser', data }),
  deleteUser: (data) => Dispatcher.dispatch({ type: 'deleteUser', data }),
  activateUser: (data) => Dispatcher.dispatch({ type: 'activateUser', data }),
  hardDeleteUser: (data) => Dispatcher.dispatch({ type: 'hardDeleteUser', data }),
  trainUser: (data) => Dispatcher.dispatch({ type: 'trainUser', data }),

  saveDecisionPage: (data) => Dispatcher.dispatch({ type: 'saveDecisionPage', data }),
  fetchSwitchDataForUWDash: (data) => Dispatcher.dispatch({ type: 'fetchSwitchDataForUWDash', data }),

  changeAssignment: (data) => Dispatcher.dispatch({ type: 'changeAssignment', data }),

  reapply: (data) => Dispatcher.dispatch({ type: 'reapply', data }),

  hardenCredit: (data) => Dispatcher.dispatch({ type: 'hardenCredit', data }),

  fetchDecisionNotes: (data) => Dispatcher.dispatch({ type: 'fetchDecisionNotes', data }),

  createDecisionNotes: (data) => Dispatcher.dispatch({ type: 'createDecisionNotes', data }),

  deleteDecisionNote: (data) => Dispatcher.dispatch({ type: 'deleteDecisionNote', data }),

  completeStips: (data) => Dispatcher.dispatch({ type: 'completeStips', data }),

  generatingDocs: (data) => Dispatcher.dispatch({ type: 'generatingDocs', data }),

  clearErrorsAndMessages: () => Dispatcher.dispatch({ type: 'clearErrorsAndMessages' }),

  clearAuthorizedSigner: () => Dispatcher.dispatch({ type: 'clearAuthorizedSigner' }),
  fetchAuthorizedSigner: (data) => Dispatcher.dispatch({ type: 'fetchAuthorizedSigner', data }),
  createAuthorizedSigner: (data) => Dispatcher.dispatch({ type: 'createAuthorizedSigner', data }),
  updateAuthorizedSigner: (data) => Dispatcher.dispatch({ type: 'updateAuthorizedSigner', data }),
  fetchAuthorizedSignerList: (data) => Dispatcher.dispatch({ type: 'fetchAuthorizedSignerList', data }),
  clearAuthorizedSignerList: (data) => Dispatcher.dispatch({ type: 'clearAuthorizedSignerList', data }),
  deleteSigner: (data) => Dispatcher.dispatch({ type: 'deleteSigner', data }),
  hardDeleteSigner: (data) => Dispatcher.dispatch({ type: 'hardDeleteSigner', data }),

  getSubscriptionList: (data) => Dispatcher.dispatch({ type: 'getSubscriptionList', data }),
  clearSubscriptionList: () => Dispatcher.dispatch({ type: 'clearSubscriptionList' }),
  getSubscription: (data) => Dispatcher.dispatch({ type: 'getSubscription', data }),
  createSubscription: (data) => Dispatcher.dispatch({ type: 'createSubscription', data }),
  updateSubscription: (data) => Dispatcher.dispatch({ type: 'updateSubscription', data }),
  deleteSubscription: (data) => Dispatcher.dispatch({ type: 'deleteSubscription', data }),
  hardDeleteSubscription: (data) => Dispatcher.dispatch({ type: 'hardDeleteSubscription', data }),
  clearSubscription: () => Dispatcher.dispatch({ type: 'clearSubscription' }),

  fetchPricingProgramNames: () => Dispatcher.dispatch({ type: 'fetchPricingProgramNames' }),

  fetchZip: (data) => Dispatcher.dispatch({ type: 'fetchZip', data }),

  changeOrder: (data) => Dispatcher.dispatch({ type: 'changeOrder', data }),

  adjustCustomer: (data) => Dispatcher.dispatch({ type: 'adjustCustomer', data }),

  fetchDisbursements: (data) => Dispatcher.dispatch({ type: 'fetchDisbursements', data }),
  fetchDisbursementsForStepMenu: (data) => Dispatcher.dispatch({ type: 'fetchDisbursementsForStepMenu', data }),
  fetchCancelledDisbursements: (data) => Dispatcher.dispatch({ type: 'fetchCancelledDisbursements', data }),
  fetchMilestoneDisbursements: (data) => Dispatcher.dispatch({ type: 'fetchMilestoneDisbursements', data }),

  setAmountFinancedZeroValidation: (data) => Dispatcher.dispatch({ type: 'setAmountFinancedZeroValidation', data }),

  getAmountFinancedZeroValidation: () => Dispatcher.dispatch({ type: 'getAmountFinancedZeroValidation' }),

  setEsignIframeSrc: (data) => Dispatcher.dispatch({ type: 'setEsignIframeSrc', data }),

  requestModals: (data) => Dispatcher.dispatch({ type: 'requestModals', data }),

  // given an object containing a modalID, closes that modal if open
  closeModal: (data) => Dispatcher.dispatch({ type: 'closeModal', data }),

  clearModalRequests: () => Dispatcher.dispatch({ type: 'clearModalRequests' }),

  fetchCustomerBannerData: (data) => Dispatcher.dispatch({ type: 'fetchCustomerBannerData', data }),

  clearCustomerBannerData: () => Dispatcher.dispatch({ type: 'clearCustomerBannerData' }),

  fetchWelcomeCallAuth: (data) => Dispatcher.dispatch({ type: 'fetchWelcomeCallAuth', data }),
  welcomeCallAuthCheck: () => Dispatcher.dispatch({ type: 'welcomeCallAuthCheck' }),

  fetchWelcomeCallByCustomerId: (data) => Dispatcher.dispatch({ type: 'fetchWelcomeCallByCustomerId', data }),

  fetchWCQuestions: (data) => Dispatcher.dispatch({ type: 'fetchWCQuestions', data }),

  putWelcomeCallQuestions: (data) => Dispatcher.dispatch({ type: 'putWelcomeCallQuestions', data }),

  fetchApplicantPII: (data) => Dispatcher.dispatch({ type: 'fetchApplicantPII', data }),

  goToDecisionDetails: (data) => Dispatcher.dispatch({ type: 'goToDecisionDetails', data }),

  goToWelcomeCall: (data) => Dispatcher.dispatch({ type: 'goToWelcomeCall', data }),

  getSuperAdminToolsData: () => Dispatcher.dispatch({ type: 'getSuperAdminToolsData' }),

  fetchLatestTrainingResource: () => Dispatcher.dispatch({ type: 'fetchLatestTrainingResource' }),

  patchUserTraining: (data) => Dispatcher.dispatch({ type: 'patchUserTraining', data }),

  fetchCustomerHoldTypes: () => Dispatcher.dispatch({ type: 'fetchCustomerHoldTypes' }),
  fetchCustomerServiceLog: () => Dispatcher.dispatch({ type: 'fetchCustomerServiceLog' }),

  fetchCustomerHistoryDetails: (data) => {
    try {
      Dispatcher.dispatch({ type: 'fetchCustomerHistory', data });
      Dispatcher.dispatch({ type: 'fetchFridHistory', data });
      Dispatcher.dispatch({ type: 'fetchCreditHistory', data });
      Dispatcher.dispatch({ type: 'fetchSnapshotHistory', data });
      Dispatcher.dispatch({ type: 'fetchWebhookEvents', data });
      Dispatcher.dispatch({ type: 'fetchSponsorApiEvents', data });
      Dispatcher.dispatch({ type: 'fetchDisbursements', data });
      Dispatcher.dispatch({ type: 'fetchNotificationAudits', data });
      Dispatcher.dispatch({ type: 'fetchCustomerAuditTrail', data });
      Dispatcher.dispatch({ type: 'fetchCustomerServiceLog', data });
    } catch (e) {
      console.log('e', e);
    }
  },

  fetchSponsorApiEvents: (data) => Dispatcher.dispatch({ type: 'fetchSponsorApiEvents', data }),

  goToCustomerProposal: (data) => Dispatcher.dispatch({ type: 'goToCustomerProposal', data }),

  submitStepDocsForReview: (data) => Dispatcher.dispatch({ type: 'submitStepDocsForReview', data }),

  editMobilePhone: (data) => Dispatcher.dispatch({ type: 'editMobilePhone', data }),

  registerNewMFADevice: (data) => Dispatcher.dispatch({ type: 'registerNewMFADevice', data }),
  registerNewMFADeviceValidate: (data) => Dispatcher.dispatch({ type: 'registerNewMFADeviceValidate', data }),
  sendMFARequest: (data) => Dispatcher.dispatch({ type: 'sendMFARequest', data }),
  validateMFARequest: (data) => Dispatcher.dispatch({ type: 'validateMFARequest', data }),
  // getMFASessions: () => Dispatcher.dispatch({ type: 'getMFASessions' }),
  // getMFADevices: () => Dispatcher.dispatch({ type: 'getMFADevices' }),
  removeMFADevice: (data) => Dispatcher.dispatch({ type: 'removeMFADevice', data }),
  // revokeMFASession: () => Dispatcher.dispatch({ type: 'revokeMFASession' }),

  getIsFreshlyLoggedIn: () => Dispatcher.dispatch({ type: 'getIsFreshlyLoggedIn' }),
  setIsFreshlyLoggedIn: (data) => Dispatcher.dispatch({ type: 'setIsFreshlyLoggedIn', data }),

  fetchPasswordResetNotificationTypes: (data) =>
    Dispatcher.dispatch({ type: 'fetchPasswordResetNotificationTypes', data }),
  generatePasswordResetOTP: (data) => Dispatcher.dispatch({ type: 'generatePasswordResetOTP', data }),
  validatePasswordResetOTP: (data) => Dispatcher.dispatch({ type: 'validatePasswordResetOTP', data }),
  fetchPasswordResetStatus: (data) => Dispatcher.dispatch({ type: 'fetchPasswordResetStatus', data }),
  resetPassword: (data) => Dispatcher.dispatch({ type: 'resetPassword', data }),

  setReduxVar: (data) => Dispatcher.dispatch({ type: 'setReduxVar', data }),

  fetchUserFinancingMethods: (data) => Dispatcher.dispatch({ type: 'fetchUserFinancingMethods', data }),

  registerFootnote: (data) => Dispatcher.dispatch({ type: 'registerFootnote', data }),
  deRegisterFootnote: (data) => Dispatcher.dispatch({ type: 'deRegisterFootnote', data }),

  submitMeasures: (data) => Dispatcher.dispatch({ type: 'submitMeasures', data }),
  retrieveMeasures: (data) => Dispatcher.dispatch({ type: 'retrieveMeasures', data }),
};

export default Actions;
